import React, { useState } from "react";
import { Button, Typography } from "@mui/joy";

interface CopyPublishedLinkProps {
  canvasId: string;
  isPublished: boolean;
  isAdmin: boolean;
}

export function publishedCanvasUrl(canvasId: string): string {
  return new URL(
    `/public/canvases/${encodeURIComponent(canvasId)}`,
    window.location.origin,
  ).toString();
}

export default function CopyPublishedLink({
  canvasId,
  isPublished,
  isAdmin,
}: CopyPublishedLinkProps) {
  const [feedback, setFeedback] = useState<string | null>(null);
  if (!isAdmin || !isPublished) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(publishedCanvasUrl(canvasId));
      setFeedback("Published link copied");
    } catch {
      setFeedback("Could not copy the published link");
    }
  };

  return (
    <>
      <Button variant="soft" onClick={() => void copy()}>
        Copy published link
      </Button>
      {feedback && (
        <Typography level="body-xs" role="status">
          {feedback}
        </Typography>
      )}
    </>
  );
}
